import React, { FunctionComponent, useMemo } from 'react'
import { Field } from 'redux-form'
import { SelectField } from '.'

interface Props {
  label: string
  name: string
  defaultOption?: string
  timezones?: string[]
}

const COMMON_TIMEZONES = new Set([
  'Eastern Time (US & Canada)',
  'Central Time (US & Canada)',
  'Mountain Time (US & Canada)',
  'Pacific Time (US & Canada)',
  'Alaska',
  'Hawaii',
  'Arizona',
  'Indiana (East)',
  'UTC',
])

export const TimezoneSelect: FunctionComponent<Props> = ({
  label,
  name,
  defaultOption = 'Select a timezone',
  timezones = [],
}) => {
  const { common, other } = useMemo(() => {
    return timezones.reduce(
      (acc, tz) => {
        acc[COMMON_TIMEZONES.has(tz) ? 'common' : 'other'].push(tz)
        return acc
      },
      { common: [] as string[], other: [] as string[] }
    )
  }, [timezones])

  const renderOptions = (zones: string[]) =>
    zones.map((tz) => (
      <option key={tz} value={tz}>
        {tz}
      </option>
    ))

  return (
    <Field label={label} name={name} component={SelectField}>
      <option value="">{defaultOption}</option>

      {!!common.length && (
        <optgroup label="Common US Timezones">
          {renderOptions(common)}
        </optgroup>
      )}

      {!!other.length && (
        <optgroup label="All Timezones">
          {renderOptions(other)}
        </optgroup>
      )}
    </Field>
  )
}

TimezoneSelect.displayName = 'TimezoneSelect'